module.exports = __webpack_public_path__ + "static/media/Angela_Ferrari_01.5f4be888.jpg";